import useWorkflowLogs from "backend/hooks/workflows/useWorkflowLogs";
import MeasureTable from "design/components/tables/MeasureTable";
import ExecutiveDashboardTitle from "design/components/texts/ExecutiveDashboardTitle";
import { t } from "i18next";
import React from "react";

const WorkflowLogs = (props: { workflowId?: string }) => {
  const { data: logs, isLoading: isLogsLoading } = useWorkflowLogs(
    props.workflowId
  );

  if (!logs) return null;
  return (
    <>
      {logs ? (
        <>
          <ExecutiveDashboardTitle>
            {t("workflowlog.Audit Log")}
          </ExecutiveDashboardTitle>
          <MeasureTable
            items={logs || []}
            columns={[
              {
                title: t("workflowlog.User").toString(),
                value: (row) => (
                  <div>
                    {row.elem.prevstate === "" ? "-" : row.elem.username}
                  </div>
                ),
              },
              {
                title: t("workflowlog.Previous State").toString(),
                value: (row) => <div>{row.elem.prevstate}</div>,
              },
              {
                title: t("workflowlog.New State").toString(),
                value: (row) => (
                  <div>
                    {row.elem.prevstate === ""
                      ? t("completedtasks.created")
                      : t("completedtasks." + row.elem.newstate)}
                  </div>
                ),
              },
              {
                title: t("workflowlog.Date").toString(),
                value: (row) => (
                  <div>{new Date(row.elem.timestamp).toLocaleString()}</div>
                ),
              },
              {
                title: t("workflowlog.Message").toString(),
                value: (row) => <div>{row.elem.message}</div>,
              },
            ]}
          />
        </>
      ) : null}
    </>
  );
};

export default WorkflowLogs;
